import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, withMethods } from '@ngrx/signals';
import { setAllEntities, setEntity, updateEntity } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';

import { Jalon } from '../../models/jalon.model';
import { UpdateJalonRequest } from '../../requests/update-jalon-request';
import { JalonService } from '../../services/jalon.service';
import { v7 as uuidv7 } from 'uuid';
import { ToastrErrorComponent } from '@shared/components/toastr/toastr-error.component';
import { toast } from 'ngx-sonner';

export function avecMéthodesJalon() {
  return signalStoreFeature(
    withMethods((store) => ({
      chargerJalons: (state: { jalons: Jalon[] }) => patchState(store, setAllEntities(state.jalons)),
      ajouterJalon: (state: { jalon: Jalon }) => patchState(store, setEntity(state.jalon)),
      modifierJalon: (state: { idJalon: string; jalon: Partial<Jalon> }) =>
        patchState(store, updateEntity({ id: state.idJalon, changes: state.jalon })),
      selectionnerJalon: (state: { idJalon: string }) => patchState(store, { selectedEntityId: state.idJalon }),
    })),
    withMethods((store, service = inject(JalonService)) => ({
      selection: rxMethod<string>(
        pipe(
          switchMap((idJalon) => service.findById(idJalon)),
          tapResponse({
            next: (jalon) => {
              store.ajouterJalon({ jalon });
            },
            error: (err) => {
              console.error(err);
              const toastrId = uuidv7();
              toast.custom(ToastrErrorComponent, {
                componentProps: {
                  message: `Un problème est survenu lors de la sélection d'un jalon, contactez le support.`,
                  id: toastrId,
                },
                id: toastrId,
              });
            },
          }),
        ),
      ),
      modifier: rxMethod<{
        idJalon: string;
        data: UpdateJalonRequest;
        next: () => void;
      }>(
        pipe(
          switchMap(({ idJalon, data, next }) =>
            service.modifier(idJalon, data).pipe(
              tapResponse({
                next: () => next(),
                error: (err) => {
                  console.error(err);
                  const toastrId = uuidv7();
                  toast.custom(ToastrErrorComponent, {
                    componentProps: {
                      message: `Un problème est survenu lors de la modification d'un jalon, contactez le support.`,
                      id: toastrId,
                    },
                    id: toastrId,
                  });
                },
              }),
            ),
          ),
        ),
      ),
    })),
  );
}
